import React from 'react';
import { Calendar } from 'src/domains/casino/webview/bonus-engine/campaign/Calendar';
import { UK_TIMEZONE } from 'src/domains/casino/webview/bonus-engine/campaign/CampaignCreator.helpers';
import { CasinoSectionState } from 'src/domains/casino/webview/bonus-engine/campaign/reward-conditions/casino-section/CasinoSection.state';
import { SportsBookSectionState } from 'src/domains/casino/webview/bonus-engine/campaign/reward-conditions/sportsbook-section/SportsBookSection.state';
import { CasinoSectionState as BonusCreationCasinoSectionState } from 'src/domains/casino/webview/bonus-engine/bonus-creator/bonus-creation/reward-conditions/casino-section/CasinoSection.state';
import { SportsBookSectionState as BonusCreationSportsbookSectionState } from 'src/domains/casino/webview/bonus-engine/bonus-creator/bonus-creation/reward-conditions/sportsbook-section/SportsBookSection.state';
import { CheckboxWithState } from 'src/domains/common/components/checkbox-with-state/checkbox-with-state';
import { Input } from 'src/domains/common/components/input/input';
import { observer } from 'src/utils/mobx-react';

type CampaignBetPlatformStateType = SportsBookSectionState | CasinoSectionState;
type BonusCreationBetPlatformType = BonusCreationSportsbookSectionState | BonusCreationCasinoSectionState;

export const SchedulingSection = observer(
    'ScheduledSection',
    ({
        state,
        editionDisabled,
    }: {
        state: CampaignBetPlatformStateType | BonusCreationBetPlatformType;
        editionDisabled: boolean;
    }) => {
        const { installmentCountForm, rewardIntervalForm, scheduledRewardForm, rewardDateForm } = state;

        return (
            <section
                data-test='scheduling'
                className='flex flex-col gap-6'
            >
                <h2 className='m-0 text-[1rem] font-semibold leading-[1.75]'>Scheduling</h2>
                <div className='grid grid-cols-2 gap-4'>
                    <Input
                        description='Enter a number between 1 and 999'
                        formInputState={installmentCountForm}
                        label='Installment Count'
                        placeholder='Type'
                        errors={installmentCountForm.errorsForView}
                        disabled={editionDisabled}
                    />
                    <Input
                        description='Enter a number between 1 and 999'
                        formInputState={rewardIntervalForm}
                        label='Reward Interval (Days)'
                        placeholder='Type'
                        errors={rewardIntervalForm.errorsForView}
                        disabled={editionDisabled}
                    />
                </div>
                <div className='grid grid-cols-2 gap-4'>
                    <CheckboxWithState
                        label='Scheduled Reward'
                        formInputState={scheduledRewardForm}
                        errors={scheduledRewardForm.errorsForView}
                        disabled={editionDisabled}
                    />
                    <Calendar
                        dataTest='start-date'
                        label='Reward Date (UK time)'
                        placeholder='*Current Date*'
                        formInputState={rewardDateForm}
                        firstDayOfWeek='monday'
                        showTimePicker={true}
                        timezone={UK_TIMEZONE}
                        errors={rewardDateForm.errorsForView}
                        disabled={scheduledRewardForm.value === false || editionDisabled}
                    />
                </div>
            </section>
        );
    }
);
